import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import PagePreview from '../entity/PagePreview';

export const startFetchingCurrentPagePreview = () =>
  produce((draft: Draft<State>) => {
    draft.currentPagePreview.fetching = draft.currentPagePreview.fetching + 1;
  });

export const setCurrentPagePreview = (currentPagePreview: PagePreview) =>
  produce((draft: Draft<State>) => {
    draft.currentPagePreview.data = currentPagePreview;
  });

export const finishFetchingCurrentPagePreview = () =>
  produce((draft: Draft<State>) => {
    draft.currentPagePreview.fetching = draft.currentPagePreview.fetching - 1;
  });

export const disposeCurrentPagePreview = () =>
  produce((draft: Draft<State>) => {
    draft.currentPagePreview.data = initialState.currentPagePreview.data;
    draft.currentPagePreview.fetching = initialState.currentPagePreview.fetching;
  });
